var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('audio',{ref:"audio",staticStyle:{"height":"0","float":"left"},attrs:{"controls":"","id":"audio","src":""}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }